import React from "react";
import {
  StyledCard,
  CvHeaderWrapper,
  CvHeader,
  CvBody,
  CvRow,
  CountBadge,
  CardTitle,
  AddButtonWrapper,
  Icon,
  LogoGroup,
  ViewIcon,
  CvRowGroup,
  EmptyMessage,
  CardSubtitle,
  LogoCount,
  CvRowWrapper,
  CvRowTitle,
  CvRowSubtitle,
} from "./styles";
import Button from "components/button";
import { ReactComponent as PlusIcon } from "assets/images/plus-icon.svg";
import { ReactComponent as PenIcon } from "assets/images/pen-icon.svg";
import { Col } from "components/shared/layout";
import { string, shape, func, arrayOf, number } from "prop-types";
import Spinner from "components/spinner";
import RoundImage from "components/round-image";
import Badge from "components/badge";

const CardHeader = ({
  count,
  variant,
  title,
  subtitle,
  onAddClick = () => {},
  divider = true,
  btnEditInd = false,
  isAddBtnVisible=true,
  isApproved=false,
}) => (
  <CvHeaderWrapper>
    <CvHeader alignItems="center" nowrap divider={divider}>
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ width: "1%" }}>
              {typeof count === "number" && (
                <CountBadge variant={variant}>
                  {isApproved
                  ? <Icon src={require("assets/images/verified-icon.svg")} style={{ position: 'inherit', boxShadow: 'none' }}/>
                  : <>{count}</>
                }
                </CountBadge>
              )}
            </td>
            <td style={{ width: '40rem' }}>
              {title && <CardTitle>
                {title}
                </CardTitle>}</td>
            <td>
            </td>
            {isAddBtnVisible && (
              <td style={{ textAlign: "right" }}>
                <AddButtonWrapper>
                  <Button onClick={onAddClick}>
                    {btnEditInd ? <PenIcon /> : <PlusIcon />}
                  </Button>
                </AddButtonWrapper>
              </td>
            )}
          </tr>
          <tr>
            <td />
            <td colSpan="2">
              {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
            </td>
          </tr>
        </tbody>
      </table>
    </CvHeader>
  </CvHeaderWrapper>
);

const LogoLeft = ({ logoUrl, verifiedAt }) => (
  <div style={{ marginRight: 18, position: "relative" }}>
    <RoundImage src={logoUrl} />
    {verifiedAt && <Icon src={require("assets/images/verified-icon.svg")} />}
  </div>
);

const EntryTitles = ({ title, subtitle }) => (
  <Col justifyContent="center">
    <CvRowTitle>{title}</CvRowTitle>
    <CvRowSubtitle>{subtitle}</CvRowSubtitle>
  </Col>
);

const RightLogos = ({ endLogos }) => {
  return (
    <LogoGroup>
      <div style={{ display: "flex" }}>
        {endLogos?.map((logoUrl, index) => {
          const length = endLogos.length;
          const remainder = length - 3;
          const lastIndex = length < 3 ? length - 1 : 2;
          return (
            index < 3 && (
              <div
                key={index}
                style={{ position: "relative", marginLeft: "-15px" }}
              >
                <RoundImage src={logoUrl} />
                <Icon src={require("assets/images/verified-icon.svg")} />
                {index === lastIndex && remainder > 0 && (
                  <LogoCount>{remainder}</LogoCount>
                )}
              </div>
            )
          );
        })}
      </div>
    </LogoGroup>
  );
};

const CvCard = ({ header, rows = [], emptyMessage, isLoading, ...rest }) => {
  return (
    <StyledCard {...rest}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <CardHeader {...header} />
          {rows.length === 0 ? (
            emptyMessage ? (
              <EmptyMessage>{emptyMessage}</EmptyMessage>
            ) : null
          ) : (
            <CvBody>
              <CvRowGroup xs={12}>
                {rows.map(
                  (
                    {
                      organisationLogoURL,
                      title,
                      subtitle,
                      endLogos,
                      onViewClick,
                      verifiedAt,
                    },
                    index
                  ) => (
                    <CvRowWrapper key={index}>
                      <CvRow
                        clickable={!!onViewClick}
                        onClick={() => (onViewClick ? onViewClick() : {})}
                      >
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td>
                                <table width="100%">
                                  <tbody>
                                    <tr>
                                      <td>
                                        {(organisationLogoURL ||
                                          verifiedAt) && (
                                          <LogoLeft
                                            logoUrl={organisationLogoURL}
                                            verifiedAt={verifiedAt}
                                          />
                                        )}
                                      </td>
                                      <td style={{ width: "100%" }}>
                                        <EntryTitles
                                          title={title}
                                          subtitle={subtitle}
                                        />
                                      </td>
                                      <td>
                                        <RightLogos
                                          endLogos={endLogos}
                                          onViewClick={onViewClick}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td style={{ textAlign: "right", width: "1%" }}>
                                {onViewClick && (
                                  <ViewIcon
                                    src={require("assets/images/chevron-down-icon.svg")}
                                    onClick={onViewClick}
                                  />
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </CvRow>
                    </CvRowWrapper>
                  )
                )}
              </CvRowGroup>
            </CvBody>
          )}
        </>
      )}
    </StyledCard>
  );
};
export default CvCard;

CvCard.defaultProps = {
  emptyMessage: "",
};

CvCard.propTypes = {
  emptyMessage: string,
  header: shape({
    title: string,
    count: number,
    onAddClick: func,
  }),
  rows: arrayOf(
    shape({
      logoUrl: string,
      title: string,
      verifiedAt: string,
      subtitle: string,
      endLogos: arrayOf(string),
      onViewClick: func,
    })
  ),
};
